import React from 'react'
import MainContainer from '../MainContainer'
import s from './footer.module.scss'
import logo from '../../utilits/img/footerlogo.svg'
import { networks, services } from './../../consts/social';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import IconButton from '@material-ui/core/IconButton';


export default function Footer() {
  return (
    <div className={s.footer}>
      <MainContainer>
        <div className={s.inner}>
          <div className={s.top}>
            <div className={s.logo}>
              <img src={logo} alt="Logo" />
            </div>
            <h5>Siz bilan hamkorlikdan hamisha mamnunmiz! <br /> Biz bilan bog’laning :)</h5>
          </div>
          <div className={s.medium}>
            <div className={s.left}>
              <h5><span></span> Biz bilan aloqada bo'ling!</h5>
              <div className={s.email}>
                <input type="text" placeholder='Email address' />
                  <IconButton >
                    <ArrowForwardIcon/>
                  </IconButton>
              </div>
            </div>
            <div className={s.right}>

              <div className={s.networks}>
                <h3><span></span> Ijtimoiy tarmoqlar</h3>
                <div className={s.items}>
                  {
                    networks.map(({ name, path }) => (
                      <a key={name} href={path}>{name}</a>
                    ))
                  }
                </div>

              </div>
              <div className={s.services}>
                <h3>
                 <span></span>
                  Xizmatlarimiz
                </h3>
                {
                  services.map(({ id, text }) => (
                    <p key={id}>{text}</p>
                  ))
                }
              </div>
            </div>
          </div>
          <div className={s.bottom}>
            <h3 className={s.left}>
              Mirzo Ulug'bek tumani, <br />
              Darxon 1-tor ko'chasi, 10
            </h3>
            <div className={s.right}>
              <a href="mailto:tasnifgroup@gmail.com">tasnifgroup@gmail.com</a>
              <a href="tel:+998938041666">893 804 16 66</a>
            </div>
          </div>
        </div>
      </MainContainer>
     <div className={s.copyright}>
       <MainContainer>
       <div className={s.inner}>
           <h3 className={s.first}>
           Tasnif group
           </h3>
           <h3 className={s.hidden}>
           Dizaynda ishonchli hamkor
           </h3>
           <h3>
           © Copyright 2021
           </h3>
       </div>
       </MainContainer>
     </div>
    </div>
  )
}
